import type { BaseMarkupComponent } from './BaseMarkupComponent.model';

export const NEW_CONDITION = 'Helt ny';
export const PERFECT_CONDITION = 'Perfekt skick';
export const GOOD_CONDITION = 'Bra skick';
export const DAMAGED_CONDITION = 'Skadat skick';

export type ListingProduct = {
  ProductId: number;
  ProductAttributeCombinationId: number;
  ProductName: string;
  ShortDescription: BaseMarkupComponent[];
  Description?: BaseMarkupComponent[];
  ManufacturerName: string;
  Category: string;
  ReleaseDateLocal: Date;
  PopularityIndex: number;
  Specifications: SpecificationDto[];
  Variants: VariantDto[];
  Categories: CategoryDto[];
  Seo: SeoDto;
  ShowOnHomePage: boolean;
  ProductLinkUrl: string;

  // Family plan
  FamilyPlansSummary?: AggregatedBundlePriceDto[];
  FamilyPlansTotalMonthlyFee?: number;
  FamilyPlansTotalRegularMonthlyFee?: number;
  FamilyPlansTotalIntermediateMonthlyFee?: number;
  FamilyPlansTotalCostOverBindingPeriod?: number;
  FamilyPlanSavings?: number;
  TotalCostOverBindingPeriod?: number;
};

export type VariantDto = {
  ProductAttributeCombinationId: number;
  ColorProductAttributeValueId: number;
  StorageSize: string;
  Condition:
    | typeof NEW_CONDITION
    | typeof PERFECT_CONDITION
    | typeof GOOD_CONDITION
    | string;
  StockQuantity: number;
  StockQuantityDescription: string;
  Sku: string;
  DisplayOrder: number;
  Color: ColorDto;
  Images: ImageDto[];
  Prices: PricesDto;
  DisableBuyButton: boolean;
};

export type SpecificationDto = {
  Name: string;
  Value: string;
};

export type ColorDto = {
  ColorName: string;
  Color: string;
};

export type ImageDto = {
  PictureUrl: string;
  AlternativeText: string;
  ProductAttributeCombinationId: number;
};

export type PricesDto = {
  Label?: LabelDto;
  BundlePrices?: AggregatedBundlePriceDto[];
  Price?: AggregatedProductPriceDto;
};

export type AggregatedBundlePriceDto = {
  BundlePriceId: number;
  Plan?: AggregatedPlanDto;
  BindingPeriod: AggregatedPeriodDto;
  ProductPrice: number;
  RegularProductPrice: number;
  Payments: AggregatedPaymentDto[];
  TotalCost: number;
  Savings: number;
  Discounts: AggregatedDiscountDto[];
  Labels: LabelDto[];
  Urgency?: string;
};

export type AggregatedProductPriceDto = {
  Price: number;
  RegularPrice?: number;
  Savings: number;
  Discounts?: AggregatedDiscountDto[];
  Labels?: LabelDto[];
  Payments: AggregatedPaymentDto[];
  Urgency: string;
  Plan?: AggregatedPlanDto;
};

export type LabelDto = {
  Color: string;
  Text: string;
};

export type AggregatedPeriodDto = {
  BindingPeriodId: number;
  Months: number;
};

export type AggregatedPaymentDto = {
  Time: number;
  DownPayment: number;
  RegularDownPayment: number;
  MonthlyPrice: number;
  RegularMonthlyPrice: number;
  SavingsMonthly: number;
  IntermediateMonthlyPrice: number;
};

export type AggregatedPlanDto = {
  PlanId: number;
  PlanName: string;
  DataAllowance: number;
  RegularDataAllowance: number;
  OfferValidityInMonthsDataAmount?: number;
  OfferValidityInMonthsDiscount?: number;
  OfferValidityInMonthsFreePeriod?: number;
  OneTimeFee?: number;
  MonthlyFee: number;
  RegularMonthlyFee: number;
  IsStudent: boolean;
  IsFamilyPlan: boolean;
  IsFamilyAllowed: boolean;
  PlanTypeId: number;
  PlanGroupId: number;
  ParentPlanIds?: number[];
};

export type CategoryDto = {
  CategoryId: number;
  CategoryName: string;
  ShowOnHomePage: boolean;
  ParentCategoryId: number;
};

export type SeoDto = {
  Title: string;
  Keywords: string;
  Description: string;
};

export type AggregatedDiscountDto = {
  DiscountId: number;
  Name: string;
  DiscountAmount: number;
  DiscountAmountUnit: string;
  Image?: {
    ImageUrl: string;
    AlternateText: string;
    Title?: string;
  };
  DiscountType: string;
  Description: string;
  DisplayOrder: number;
  DiscountProducts: AggregatedPopupDiscountProductsDto[];
  CouponCodesNotAllowed: boolean;
  LabelText: string;
  LabelColor: string;
  RequiresCouponCode: boolean;
  CouponCode: string;
  IsPopup: boolean;
  PopupPriceMonthly: number;
  PopupPrice: AggregatedPopupPriceDto[];
  PopupContent?: AggregatedPopupDiscountDto[];
  ShortDescriptionShoppingCart: BaseMarkupComponent[];
};

export type AggregatedPopupDiscountProductsDto = {
  Category: string;
  InsuranceLevel?: string;
  Color?: string;
  Manufacturer: string;
  Price: number;
  ProductAttributeCombinationId: number;
  ProductName: string;
};

export type AggregatedPopupPriceDto = {
  Price: number;
  RegularPrice?: number;
};

export type AggregatedPopupDiscountDto = {
  Component: string;
  DiscountId: number;
  DisplayOrder: number;
  Title: string;
  SubTitle: string;
  ImageUrl: string;
  ShortDescription: string;
  ChargingInfo?: {
    chargerIncluded: boolean;
    wiredChargerMinWatts: string;
    wiredChargerMaxWatts: string;
    usbPdSupported?: boolean;
  };
  UspItems: { label: string; subLabel?: string }[];
};
